import React from "react";
import _ from "underscore";
import FilterFieldsetHeader from "./filter-fieldset-header";
import Details from "./details";
import FilterInputPairs from "./filter-input-pairs";

class DesignersFilter extends React.Component {
  state = {
    allDesigners: this.props.values,
    displayedDesigners: this.props.values,
  };

  filterDesigners = value => {
    var searchText = value.toLowerCase();

    if (searchText === "") {
      this.setState({
        displayedDesigners: this.state.allDesigners,
        searchText: "",
      });
      return;
    }
    var regex = new RegExp(searchText, "i");

    var filteredDesigners = _.filter(this.props.values, function (designer) {
      return designer.displayName.match(regex) !== null;
    });

    this.setState({
      displayedDesigners: filteredDesigners,
      searchText: searchText,
    });
  };

  handleChange = event => {
    var value = event.target.value;
    this.debounceChange(value);
  };

  UNSAFE_componentWillMount() {
    var ctx = this;
    this.debounceChange = _.debounce(function (e) {
      ctx.filterDesigners(e);
    }, 100);
  }

  clear = event => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    this.onClear(this.props.keyName);
  };

  onToggle = (component, open) => {
    this.props.onToggleOpenFilters(this.props.keyName, open);
  };

  onChange = filter => {
    this.props.onChange(filter);
    this.props.submitFilters();
  };

  render() {
    var results;

    if (this.state.displayedDesigners.length === 0) {
      results = <div>No Results!</div>;
    } else {
      results = <FilterInputPairs {...this.props} onChange={this.onChange} values={this.state.displayedDesigners} />;
    }

    return (
      <Details
        className="filter-fieldset designers-filter"
        open={this.props.filterOpen}
        onToggle={this.onToggle}
        controlled={true}>
        <FilterFieldsetHeader
          displayClear={!!this.props.filters?.length}
          title={this.props.fieldsetHeader || this.props.displayName}
          onClear={this.clear}
        />
        <div className="designers-wrapper">
          <input
            onChange={this.handleChange}
            type="text"
            placeholder="Search for a designer"
            id={"designer-search" + this.props.idSuffix}
          />
          <div className="designers">{results}</div>
        </div>
      </Details>
    );
  }
}

export default DesignersFilter;
